<template>
    <v-card outlined :width="600">
        <my-toolbar :height="55" :title="'User Profile'"></my-toolbar>
        <v-card-text v-if="loading">
            <span>Loading User...</span>
        </v-card-text>
        <div v-else>
            <v-card-text>
                <v-text-field v-model="userData.user_name" label="Username"></v-text-field>
                <v-text-field v-model="userData.employee_id" label="Employee ID"></v-text-field>
                <v-text-field v-model="userData.email" label="Email"></v-text-field>
                <v-text-field v-model="userData.first_name" label="First Name"></v-text-field>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="px-5 mr-2" depressed color="primary" @click="handleUpdate">Update</v-btn>
            </v-card-actions>
        </div>
    </v-card>
</template>

<script>
export default {
    data: () => ({
        userData: null,
        loading: false
    }),
    created(){
        this.loadUser()
    },
    methods: {
        async loadUser(){
            this.$Progress.start();
            this.loading = true
            try {
                let response = await this.$http.get('/auth');
                this.userData = response.data
                this.loading = false
                this.$Progress.finish();
            } catch (error) {
                this.$toast.open({
                    message: 'Unauthorized! Please login.',
                    type: "error"
                });
                this.$router.push('/login')
                this.loading = false
                this.$Progress.fail();
            }
        },
        handleUpdate(){
            this.$toast.open({
                message: 'This functionality will be work on soon...',
                type: "warning"
            });
        }
    }
}
</script>